import type { Components, Theme } from '@mui/material';

export const MuiListSubheader: Components<Omit<Theme, 'components'>>['MuiListSubheader'] = {
  styleOverrides: {
    root: {
      padding: '8px 22px',
    },
  },
};
